import { API_CALL } from 'actions/actionConstants'
import { UPDATE_RECENTLY_VIEWED_MERCHANDISE } from 'actions/apiActionConstants'
import type { AppAction } from 'actions/types/ActionTypes'
import getRecentlyViewedMerchandise from 'api/merchandise/getRecentlyViewedMerchandise'
import setRecentlyViewedMerchandise from 'api/merchandise/setRecentlyViewedMerchandise'
import { take, without } from 'lib/array/arrayUtils'

function updateRecentlyViewedMerchandise(merchandiseId: string): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    let existingIds = state.merchandise.recentlyViewedMerchandise?.merchandiseIds ?? []

    if (existingIds[0] === merchandiseId) {
      // this merchandise id is already the most recently veiwed
      return
    }

    dispatch({
      type: API_CALL,
      api: UPDATE_RECENTLY_VIEWED_MERCHANDISE,
      request: async() => {
        if (
          !state.merchandise.recentlyViewedMerchandise?.merchandiseIds ||
          state.merchandise.recentlyViewedMerchandise.fetching
        ) {
          // never been fetched! (or is currently being fetched)
          // So go get our original list so we don't accidently wipe it out
          existingIds = await getRecentlyViewedMerchandise()
        }
        const nextRecentlyViewed = take([merchandiseId, ...without(existingIds, merchandiseId)], 12)
        return setRecentlyViewedMerchandise(nextRecentlyViewed)
      },
    })
  }
}

export default updateRecentlyViewedMerchandise
